export const stats = [
  {
    id: 1,
    icon: "users",
    value: "10k+",
    label: "Students"
  },
  {
    id: 2,
    icon: "trophy",
    value: "500+",
    label: "Successes"
  },
  {
    id: 3,
    icon: "calendar",
    value: "18",
    label: "Years of Experience"
  }
];

export const features = [
  {
    id: 1,
    icon: "BookOpen",
    title: "Quality Teaching",
    description: "Exceptional classroom instruction by expert educators."
  },
  {
    id: 2,
    icon: "User",
    title: "Personal Attention",
    description: "Tailored guidance and support for every student."
  },
  {
    id: 3,
    icon: "FileText",
    title: "Comprehensive Material",
    description: "Pattern-proof study resources for thorough preparation."
  },
  {
    id: 4,
    icon: "TrendingUp",
    title: "Performance Tracking",
    description: "Boost success with Rank Potential Index and improvement programs."
  },
  {
    id: 5,
    icon: "Target",
    title: "Consistent Practice",
    description: "Regular practice problems and assessments to ensure readiness."
  },
  {
    id: 6,
    icon: "Clock",
    title: "Flexible Scheduling",
    description: "Morning and evening batches with online tests for JEE/NEET."
  }
];

export const courses = [
  {
    id: "KCC01",
    title: "IIT JEE Chemistry",
    category: "Chemistry",
    students: 1200,
    rating: 4.8,
    image: "https://images.unsplash.com/photo-1532094349884-543bc11b234d?w=800&q=80",
    description: "Comprehensive chemistry course designed specifically for IIT JEE aspirants. Master all three domains - Physical, Organic, and Inorganic Chemistry.",
    duration: "2 Years",
    level: "Advanced",
    batchSize: "25-30",
    schedule: "Mon-Fri: 6:00 PM - 8:00 PM, Sat: 10:00 AM - 2:00 PM",
    features: [
      "Complete syllabus coverage for JEE Main & Advanced",
      "200+ hours of live interactive classes",
      "1000+ practice problems with detailed solutions",
      "Weekly test series and performance analysis",
      "Concept clarity sessions and doubt clearing",
      "Previous years' JEE questions analysis",
      "Study material and revision notes",
      "24/7 doubt support via WhatsApp"
    ],
    highlights: [
      "Top faculty with 18 years experience",
      "95% success rate in JEE Advanced",
      "Small batch size (max 30 students)",
      "Personal mentorship and guidance"
    ],
    curriculum: [
      {
        title: "Physical Chemistry",
        topics: ["Atomic Structure", "Chemical Bonding", "States of Matter", "Thermodynamics", "Chemical Equilibrium", "Ionic Equilibrium", "Electrochemistry", "Chemical Kinetics", "Surface Chemistry", "Solutions"]
      },
      {
        title: "Organic Chemistry",
        topics: ["Basic Concepts", "Hydrocarbons", "Haloalkanes & Haloarenes", "Alcohols, Phenols & Ethers", "Aldehydes & Ketones", "Carboxylic Acids", "Amines", "Biomolecules", "Polymers", "Chemistry in Everyday Life"]
      },
      {
        title: "Inorganic Chemistry",
        topics: ["Periodic Table", "Hydrogen", "S-Block Elements", "P-Block Elements", "D & F Block Elements", "Coordination Compounds", "Environmental Chemistry", "General Principles", "Metals & Metallurgy", "Qualitative Analysis"]
      }
    ],
    modules: [
      { name: "Foundation Module", duration: "2 months", description: "Building strong fundamentals with NCERT coverage" },
      { name: "Advanced Module", duration: "6 months", description: "JEE Advanced level problem solving" },
      { name: "Revision Module", duration: "3 months", description: "Comprehensive revision with mock tests" },
      { name: "Final Sprint", duration: "1 month", description: "Last minute preparation and strategy" }
    ],
    testimonials: [
      { name: "Srijit Dutta", rank: "AIR 450, JEE Advanced", comment: "Best chemistry classes in Kolkata" },
      { name: "Akash Mandal", rank: "AIR 1270, JEE Advanced", comment: "Sir's teaching methodology is unmatched" }
    ]
  },
  {
    id: "KCC02",
    title: "NEET Chemistry Specialization",
    category: "Chemistry",
    students: 850,
    rating: 4.7,
    image: "https://images.unsplash.com/photo-1576086213369-97a306d36557?w=800&q=80",
    description: "Specialized NEET chemistry program focusing on medical entrance exam patterns and NCERT-based conceptual understanding.",
    duration: "2 Years",
    level: "Advanced",
    batchSize: "20-25",
    schedule: "Tue-Thu-Sat: 4:00 PM - 6:30 PM, Sun: 9:00 AM - 1:00 PM",
    features: [
      "Complete NEET chemistry syllabus coverage",
      "NCERT line-by-line explanation",
      "800+ NEET-style practice questions",
      "Biology-chemistry integration concepts",
      "Monthly full-length mock tests",
      "Previous 10 years NEET papers solved",
      "Quick revision techniques",
      "Medical terminology in chemistry"
    ],
    highlights: [
      "NEET-specific teaching methodology",
      "Focus on speed and accuracy",
      "Top AIIMS & NEET rankers as mentors",
      "90% students score above 160/180"
    ],
    curriculum: [
      {
        title: "Class 11 Chemistry",
        topics: ["Basic Concepts", "Structure of Atom", "Chemical Bonding", "States of Matter", "Thermodynamics", "Equilibrium", "Redox Reactions", "Hydrogen", "S-Block Elements", "P-Block Elements", "Organic Chemistry Basics", "Hydrocarbons", "Environmental Chemistry"]
      },
      {
        title: "Class 12 Chemistry",
        topics: ["Solid State", "Solutions", "Electrochemistry", "Chemical Kinetics", "Surface Chemistry", "General Principles", "P-Block Elements", "D & F Block", "Coordination Compounds", "Haloalkanes", "Alcohols & Ethers", "Aldehydes & Ketones", "Carboxylic Acids", "Amines", "Biomolecules", "Polymers"]
      }
    ],
    modules: [
      { name: "NCERT Mastery", duration: "3 months", description: "Line by line NCERT coverage with examples" },
      { name: "NEET Pattern Practice", duration: "5 months", description: "NEET-specific questions and shortcuts" },
      { name: "Mock Test Series", duration: "3 months", description: "50+ full-length mock tests" },
      { name: "Rapid Revision", duration: "1 month", description: "Speed revision with memory techniques" }
    ],
    testimonials: [
      { name: "Rajorshi Ram", rank: "NRS Medical College", comment: "Cleared NEET with excellent chemistry score" },
      { name: "Rohan Mishra", rank: "AIR 236, NEET", comment: "Chemistry was my strength thanks to Koley Sir" }
    ]
  },
  {
    id: "KCC03",
    title: "Chemistry Foundation for School Students (Class 7-10)",
    category: "Chemistry",
    students: 640,
    rating: 4.7,
    image: "https://images.unsplash.com/photo-1616400619175-5beda3a17896?w=800&q=80",
    description: "Strong foundation chemistry course for Class 7-10 students focusing on conceptual clarity and school exam excellence.",
    duration: "2 Years",
    level: "Intermediate",
    batchSize: "30-35",
    schedule: "Mon-Wed-Fri: 5:00 PM - 7:00 PM",
    features: [
      "Class 7-10 syllabus coverage (CBSE/ICSE/WBBSE)",
      "School exam pattern and marking scheme",
      "Chapter-wise tests and assessments",
      "Practical demonstrations and activities",
      "Notes, worksheets, and concept maps",
      "Sample papers and question practice",
      "Interactive doubt sessions",
      "Parent-teacher meetings quarterly"
    ],
    highlights: [
      "Perfect for building strong basics",
      "Builds strong chemistry foundation",
      "100% board exam success rate",
      "Average score improvement of 25%"
    ],
    curriculum: [
      {
        title: "Class 7-8 Topics",
        topics: ["Matter and its states", "Atoms and molecules", "Physical and chemical changes", "Elements, compounds and mixtures", "Acids, bases and salts (basics)", "Introduction to metals and non-metals"]
      },
      {
        title: "Class 9-10 Topics",
        topics: ["Chemical reactions and equations", "Structure of atom (school level)", "Periodic table (school level)", "Metals and non-metals", "Carbon and its compounds (basics)", "Environmental chemistry (basics)"]
      }
    ],
    modules: [
      { name: "Concept Building", duration: "4 months", description: "Foundation building with core concepts" },
      { name: "Practice & Tests", duration: "3 months", description: "Chapter-wise practice and assessment" },
      { name: "School Exam Prep", duration: "2 months", description: "Sample papers and exam strategy" },
      { name: "Final Revision", duration: "1 month", description: "Quick revision with important questions" }
    ],
    testimonials: [
      { name: "Sneha Agarwal", rank: "98% in Chemistry", comment: "Board exams became easy after joining KCC" },
      { name: "Ankit Sharma", rank: "96% in Chemistry", comment: "Excellent teaching for school students" }
    ]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Srijit Dutta",
    initials: "SD",
    institution: "IIT Bombay",
    rating: 5,
    title: "Great platform",
    content: "I would like to thank Koley Sir for his guidance and extraordinary contribution during my JEE preparation to help me to succeed in JEE Advanced. Sir's friendly nature makes him very approachable. You can approach him with any difficulties you are facing and he takes time out of his schedule to help you."
  },
  {
    id: 2,
    name: "Akash Mandal",
    initials: "AM",
    institution: "IIT Kharagpur",
    rating: 4,
    title: "Excellent courses",
    content: "I am currently studying Mathematics and Computing at IIT Kharagpur. I secured a rank of 1270 in JEE Advanced. Sir's dedication, brilliance, and focus are unmatched when it comes to JEE preparation. My personal favourite classes would be when sir taught reaction mechanisms."
  },
  {
    id: 3,
    name: "Yashvardhan Didwania",
    initials: "YD",
    institution: "IIT Bombay",
    rating: 5,
    title: "Highly Recommend",
    content: "I secured a rank of 415 in JEE Advanced 2016, and 1 in WBJEE. The technique of teaching used by Koley sir is very unique. He is personally invested in the learning of his students and goes above and beyond the limits of the syllabus to deliver a comprehensive learning environment."
  },
  {
    id: 4,
    name: "Rajorshi Ram",
    initials: "RR",
    institution: "NRS Medical College",
    rating: 5,
    title: "Guided to Success",
    content: "During my NEET preparation, I was fortunate to be taught by Koley Sir. His deep understanding of the subject and his ability to simplify complex concepts made learning chemistry an enjoyable experience. His unique teaching style ensured that I not only understood the topics but also mastered them."
  },
  {
    id: 5,
    name: "Aniruddha Mahapatra",
    initials: "AM",
    institution: "IIT Roorkee",
    rating: 4,
    title: "Grateful for Excellent Guidance",
    content: "I secured a rank of 1683 in JEE Advanced and 480 in KVPY. His approach to teaching chemistry, especially organic chemistry, goes beyond rote learning and focuses on building a strong conceptual foundation."
  },
  {
    id: 6,
    name: "Sombuddha Chakravarty",
    initials: "SC",
    institution: "BITS Pilani",
    rating: 5,
    title: "Transformative Teaching",
    content: "With a score of 378 in BITSAT and a rank of 5248 in JEE Advanced, I can confidently say that Koley Sir's teaching was pivotal in my preparation. His ability to cover the vast chemistry syllabus with clarity and precision made all the difference."
  },
  {
    id: 7,
    name: "Rohan Mishra",
    initials: "RM",
    institution: "AIIMS Delhi",
    rating: 5,
    title: "Gratitude Beyond Words",
    content: "Thanks to his guidance, I achieved an All India Rank of 236 in NEET. Sir's mentorship was crucial to my success, and I will always be grateful for his unwavering support."
  },
  {
    id: 8,
    name: "Sneha Agarwal",
    initials: "SA",
    institution: "BITS Pilani",
    rating: 5,
    title: "Achieving the Impossible",
    content: "I used to dread chemistry, but Koley Sir changed that entirely. Under his mentorship, I scored 98 in chemistry in my JEE Mains and secured a seat at BITS. The way Sir breaks down difficult concepts into digestible parts is unmatched."
  }
];

export const methodologies = [
  {
    id: 1,
    title: "proficiency level",
    level: "High",
    description: "Do not dilute preparation of any topic due to external factors like school work. Unlike school/board exams, you cannot score in NEET/JEE without reaching a certain level of proficiency."
  },
  {
    id: 2,
    title: "analytical skills",
    level: "High",
    description: "Develop your analytical skills by not giving up after one or two attempts at solving a problem. Analytical approach is essential for NEET(UG)/JEE-MAIN-ADVANCED."
  },
  {
    id: 3,
    title: "conceptual application",
    level: "Critical",
    description: "Understanding concepts alone is inadequate. Students must learn to apply these concepts in solving tricky problems, which often involve more than one basic concept in NEET/JEE."
  },
  {
    id: 4,
    title: "gap understanding",
    level: "High",
    description: "There is a significant difference between the level of chemistry in Class X and Class XI. NEET/JEE preparation requires a different approach and higher analytical skills."
  },
  {
    id: 5,
    title: "time optimization",
    level: "Essential",
    description: "Optimal use of time is crucial for NEET/JEE preparation. This includes the realignment of extracurricular and sports activities to focus more on studies."
  },
  {
    id: 6,
    title: "comprehensive understanding",
    level: "Critical",
    description: "The right mix of classes, problem-solving sessions, and doubt sessions, supported by in-depth study material, will help students develop a comprehensive understanding."
  }
];

export const services = [
  {
    id: 1,
    icon: "Target",
    title: "Student Specific Improvement Plan",
    description: "Tailored plans to address individual student's weaknesses and strengths, ensuring focused improvement."
  },
  {
    id: 2,
    icon: "Brain",
    title: "AI-Based Question Bank",
    description: "Comprehensive AI-driven chemistry question bank offering unlimited practice material."
  },
  {
    id: 3,
    icon: "BarChart3",
    title: "Personalised Test Analysis",
    description: "Customized analysis of each test to highlight areas for improvement."
  },
  {
    id: 4,
    icon: "BookOpen",
    title: "Unlimited Revision Material",
    description: "Access to extensive revision resources for thorough preparation."
  },
  {
    id: 5,
    icon: "Clock",
    title: "Accuracy and Timing Analysis",
    description: "Detailed analysis of test accuracy and time management for every attempt."
  },
  {
    id: 6,
    icon: "TrendingUp",
    title: "Progress Evaluation",
    description: "In-depth evaluation of skill levels over time to track improvement."
  },
  {
    id: 7,
    icon: "LayoutDashboard",
    title: "Interactive Dashboard",
    description: "User-friendly dashboard that provides easy access to progress and performance data."
  },
  {
    id: 8,
    icon: "FileText",
    title: "Focused Chapter Analysis",
    description: "Deep and focused analysis of each chapter to identify key areas for improvement."
  },
  {
    id: 9,
    icon: "Activity",
    title: "Performance Progress Analysis",
    description: "Comprehensive analysis of student progress to boost performance."
  }
];

export const kccOffers = [
  {
    id: 1,
    title: "QUIZZES",
    description: "For almost all topics you will be given objective type quizzes."
  },
  {
    id: 2,
    title: "DEEP ANALYTICS ACROSS SESSIONS",
    description: "Unlike traditional methods, working on the KCC platform provides deep and progressive analytics across multiple parameters."
  },
  {
    id: 3,
    title: "IMPROVED ACADEMIC RESULTS",
    description: "The platform is geared to provide personalized improvement plans and focus areas for each student."
  },
  {
    id: 4,
    title: "COMPREHENSIVE LEARNING & PRACTICE",
    description: "Students from 7th to 12th and those appearing for JEE/NEET can access KCC's learning material and large number of questions."
  },
  {
    id: 5,
    title: "STUDY MATERIAL",
    description: "All students are provided with study material which contains detailed theory with appropriate illustrations and solved problems."
  },
  {
    id: 6,
    title: "MODULES & MODULE TESTS",
    description: "All long-term courses have been broken up into modules. At the end of each module, students are tested for their proficiency."
  },
  {
    id: 7,
    title: "SDCC (STUDENT DOUBT CLEARING CLASSES)",
    description: "Faculty members are available during working hours on all working days for clearing doubts."
  },
  {
    id: 8,
    title: "G-FILE (GENIUS FILE)",
    description: "Students are provided with G-File, a very popular problem package with a large number of questions and solutions."
  },
  {
    id: 9,
    title: "SIMULATOR QUESTION BANK FILE (S.Q.B-FILE)",
    description: "A unique package comprising a large number of questions which is ideal for final practice."
  }
];
